import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { TemplateBasicModel, TemplateModel, TemplateSaveModel } from './templates.model';
import { SearchModel, SearchResultModel } from 'src/common/components';

@Injectable()
export class TemplatesService {

	constructor(private http: HttpClient) { }

	searchTemplateTicketBasic(search: SearchModel): Promise<SearchResultModel<TemplateBasicModel>> {
		return this.http.post<SearchResultModel<TemplateBasicModel>>(`${environment.apiUrl}/Templates/TemplateTicketBasicSearch`, search).toPromise();
	}

	saveTemplateTicket(model: TemplateSaveModel): Promise<void> {
		return this.http.post<void>(`${environment.apiUrl}/Templates/SaveTemplateTicket`, model).toPromise();
	}

	saveTemplateCommercialLegalCondition(model: TemplateSaveModel): Promise<void> {
		return this.http.post<void>(`${environment.apiUrl}/Templates/SaveTemplateCommercialLegalCondition`, model).toPromise();
	}

	getTemplateTicket(id: number): Promise<TemplateModel> {
		return this.http.get<TemplateModel>(`${environment.apiUrl}/Templates/GetTemplateTicket/${id}`).toPromise();
	}

	getTemplateCommercialLegalCondition(id: number): Promise<TemplateModel> {
		return this.http.get<TemplateModel>(`${environment.apiUrl}/Templates/GetTemplateCommercialLegalCondition/${id}`).toPromise();
	}

	deleteTemplateTicket(id: number): Promise<void> {
		return this.http.delete<void>(`${environment.apiUrl}/Templates/DeleteTemplateTicket/${id}`).toPromise();
	}

	deleteTemplateCommercialLegalCondition(id: number): Promise<void> {
		return this.http.delete<void>(`${environment.apiUrl}/Templates/DeleteTemplateCommercialLegalCondition/${id}`).toPromise();
	}
}
